import { Pipe, PipeTransform } from '@angular/core';
import { SchemaTranslations } from '@app/shared/models/schema-translations';

@Pipe({
  name: 'schemaTranslationsGetFieldTranslations',
})

export class SchemaTranslationsGetFieldTranslationsPipe implements PipeTransform {
  public transform(schemaTranslations: SchemaTranslations | null, controlName: string): string | undefined {
    return schemaTranslations?.getFieldTranslation(controlName);
  }
}
